import Phaser from "phaser";
import { GAME_HEIGHT, GAME_WIDTH } from "../constants";
import type { LevelTheme } from "../data/levels";
import { SKY_COLORS } from "./modernArt";

/**
 * Flat 1985-style sky. Hills, bushes, clouds and trunks are placed by the
 * level grid (see LevelScene.createDeco), so the backdrop itself is just a
 * solid colour plus a dimmer used while paused.
 */
export class WorldBackdrop {
  private readonly sky: Phaser.GameObjects.Rectangle;
  private readonly dimmer: Phaser.GameObjects.Rectangle;

  constructor(scene: Phaser.Scene, theme: LevelTheme) {
    this.sky = scene.add
      .rectangle(0, 0, GAME_WIDTH, GAME_HEIGHT, SKY_COLORS[theme], 1)
      .setOrigin(0)
      .setScrollFactor(0)
      .setDepth(-30);
    this.dimmer = scene.add
      .rectangle(0, 0, GAME_WIDTH, GAME_HEIGHT, 0x000000, 0)
      .setOrigin(0)
      .setScrollFactor(0)
      .setDepth(45);
  }

  update(_scrollX: number, _time: number, _delta: number): void {
    // Nothing scrolls: the sky is a flat colour.
  }

  setPaused(paused: boolean): void {
    this.dimmer.setAlpha(paused ? 0.45 : 0);
  }

  destroy(): void {
    this.sky.destroy();
    this.dimmer.destroy();
  }
}
